<template>
    <b-form-group class="filter-table-wrapper">
        <table class="table p-0 filter-custom-table">
            <tbody>
            <tr v-for="column in Object.keys(filters)" :key="column">
                <td class="text-center head" align-self="center">
                    {{ column }}
                </td>
                <td>
                <b-form-checkbox-group v-slot="{ ariaDescribedby }" :label="column" v-model="selectedFilters[column]" @change="emitUpdateFilters">
                <!-- <b-form-checkbox-group v-slot="{ ariaDescribedby }" :label="column" v-model="selectedCategory[column]">   -->
                    <b-form-checkbox class="mr-3" :aria-describedby="ariaDescribedby" :name="column+'-checkbox'"
                        v-for="(item, i) in filters[column]" :key="i" :value="item">{{ item }}
                    </b-form-checkbox>
                </b-form-checkbox-group>
                </td>
            </tr>
            <tr v-if="useIntervalFilters">
                <td class="text-center head">
                    From ~ To
                </td>
                <td>
                    <b-row class="d-flex align-items-center justify-content-start">
                        <b-col cols="6" sm="3" class="form-inline">
                            <b-input-group style="width: 100%;" class="d-flex align-items-center filter-custom-input">
                                <b-form-input id="filters-from" name="filters-from" type="text" v-model="selectedFilters.from" class="custom-input rounded p-1 pl-2"
                                placeholder="YYYY-MM-DD" size="sm" @keyup.enter="emitUpdateFilters"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker id="date-picker" v-model="selectedFilters.from" button-only right></b-form-datepicker>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        ~
                        <b-col cols="6" sm="3" class="form-inline">
                            <b-input-group style="width: 100%;" class="d-flex align-items-center filter-custom-input">
                                <b-form-input id="filters-to" name="filters-to" type="text" v-model="selectedFilters.to" class="custom-input rounded p-1 pl-2"
                                placeholder="YYYY-MM-DD" size="sm" @keyup.enter="emitUpdateFilters"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker id="date-picker" v-model="selectedFilters.to" button-only right></b-form-datepicker>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </td>
            </tr>
            <tr  v-if="useIntervalFilters">
                <td class="text-center head">
                    Interval
                </td>
                <td>
                    <b-row class="d-flex align-items-center justify-content-start">
                        <b-col cols="2" class="">
                            <b-form-input id="filters-interval" name="filters-interval" type="number" v-model="selectedFilters.interval"
                            class="custom-input rounded p-1 pl-2 m-0" placeholder="7" size="sm" @keyup.enter="emitUpdateFilters" @input="resetDay" ></b-form-input>
                        </b-col>
                        Days
                    </b-row>
                    
                </td>
            </tr> 
            <tr v-if=" componentName === 'ProjectStatusProgressGraph' && useIntervalFilters">
                <td class="text-center head">
                    Day
                </td>
                <td>
                    <b-row class="mr-3 custom-control custom-control-inline custom-checkbox">
                        <b-form-checkbox  class="mr-3" v-for="(eow, index) in daysOfWeek" :disabled="selectedFilters.interval !== ''"
                            :key="index" :value="String(index)" v-model="selectedFilters['eow']" @keyup.enter="emitUpdateFilters"
                            :checked="eow === '금'">
                            {{ eow }}
                        </b-form-checkbox>
                    </b-row>
                </td>
            </tr>
            </tbody>
        </table>
    </b-form-group>
</template>
  <script>
  export default {
    props: [
        'metaData',
        'componentName',
        'filterType'
    ],
    created() {
        // 23-09-08 데이터 정합성을 위해 사용하는 테이블의 데이터로 filter 생성하도록 변경
        // if(this.componentName == 'ProgramTestDistributionGraph') {
        //     this.createFilters(this.testCaseFilterMeta, this.metaData.testCase);
        //     this.useOptionalFilter = false;
        // } else {
        //     historyFilters()
        // }

        this.createFilters();
    },
    computed: {
        isIntervalDisabled() {
            return this.selectedFilters.eow !== undefined && this.selectedFilters.eow !== '';
        }
    },
    data() {
        return {
            filters : {},

            historyFilterMeta : {
                'L1' : 'l1',
                'L2' : 'l2',
                'L3' : 'l3',
                'L4' : 'l4',
                'L5' : 'l5',
                'PRIORITY' : 'priority',
                'TYPE' : 'type',
                'JOB' : 'job',
                'BUSINESS_CATEGORY' : 'businessCategory'
            },

            snapshotFilterMeta : {
                'L1' : 'l1',
                'L2' : 'l2',
                'L3' : 'l3',
                'L4' : 'l4',
                'L5' : 'l5',
                'PRIORITY' : 'priority',
                'TYPE' : 'type',
                'JOB' : 'job',
                'BUSINESS_CATEGORY' : 'businessCategory'
            },

            testCaseFilterMeta : {
                'Round' : 'round'
            },

            selectedFilters: {
                
            },

            optionalFilters: {
                from : '',
                to : '',
                interval : '',
                eow : 5
            },
            useIntervalFilters : false,
            daysOfWeek: ["일", "월", "화", "수", "목", "금", "토"]
        }
    },
    methods:{
        createFilters() {
            switch (this.filterType) {
                case 'history' :
                    this.filters = this.historyFilters(); break;
                case 'snapshot' : 
                    this.filters = this.snapshotFilters(); break;
                case 'testCase' :
                    this.filters = this.testCaseFilters();
                    this.useIntervalFilters = false;
                    break;
            }    
            
            // ProjectStatusProgressGraph,
            // ChatterFlexibleDashboardCard2,
            // ProjectPlanAndActualGraph,
            // ProjectOutputGraph,
            // ProjectProductivityGraph,
            // ProgramTestDistributionGraph,
            // BugReportGraph,
            // CompletionPeriodGraph,
            // ProgramCreationDateDistributionGraph,
            // CurrentStatusGraph,
            // ChangedYesterdayGraph,
            // ChangedTodayGraph,
            // ProjectManMonthGraph,
            // ChatterActivationGraph
            switch (this.componentName) {
                case 'ProjectStatusProgressGraph':
                case 'ProjectPlanAndActualGraph':
                case 'ProgramCreationDateDistributionGraph':
                case 'ChatterActivationGraph':
                case 'ProjectManMonthGraph':
                case 'ProjectProductivityGraph':
                    this.useIntervalFilters = true;
                    break;
                default:
                    break;
            }
            

            this.selectedFilters = Object.assign({}, this.filters, this.optionalFilters);
            this.emitUpdateFilters();
        },
        emitUpdateFilters() {
            console.log("emitReload 호출");
            this.$emit('update:filters', this.selectedFilters);
        },

        historyFilters() {
            let filters = {};

            let metaData = this.metaData.history;

            const filterKeyArray = Object.keys(this.historyFilterMeta);

            filterKeyArray.forEach(key => {
                filters[key] = [];
            });
            
            for(let data of metaData) {
                filterKeyArray.forEach(key => {
                    if(data[this.historyFilterMeta[key]] != '') {
                        filters[key].push(data[this.historyFilterMeta[key]]);
                    }
                });
            }

            filterKeyArray.forEach(key => {
                filters[key] = [...new Set(filters[key])];
                filters[key].unshift("None");
            });

            return filters;
        },

        snapshotFilters() {
            let filters = {};

            let metaData = this.metaData.snapshot;

            const filterKeyArray = Object.keys(this.snapshotFilterMeta);

            filterKeyArray.forEach(key => {
                filters[key] = [];
            });
            
            for(let data of metaData) {
                filterKeyArray.forEach(key => {
                    if(data[this.snapshotFilterMeta[key]] != '') {
                        filters[key].push(data[this.snapshotFilterMeta[key]]);
                    }
                });
            }

            filterKeyArray.forEach(key => {
                filters[key] = [...new Set(filters[key])];
                filters[key].unshift("None");
            });

            return filters;
        },

        testCaseFilters() {
            let filters = {};

            let metaData = this.metaData.testCase;

            const filterKeyArray = Object.keys(this.testCaseFilterMeta);

            filterKeyArray.forEach(key => {
                filters[key] = [];
            });
            
            for(let data of metaData) {
                filterKeyArray.forEach(key => {
                    if(data[this.testCaseFilterMeta[key]] != '') {
                        filters[key].push(data[this.testCaseFilterMeta[key]]);
                    }
                });
            }

            filterKeyArray.forEach(key => {
                filters[key] = [...new Set(filters[key])];
                filters[key].unshift("None");
            });

            return filters;
        },
        resetDay() {

            if(this.selectedFilters.interval !== ''){
                this.selectedFilters.eow = '';
            }else{
                this.selectedFilters.eow = '5';
            }
        }
        
        // initFilters() {
        //     console.log("initFilters 호출");
        //     console.log(this.metaData);

        //     let period = {
        //         from : '',
        //         to : ''
        //     }

        //     this.filters = Object.assign({}, this.metaData, period);
            
        //     console.log(this.filters);
        //     this.emitUpdateFilters();
        // }
    }
  }
  </script>
<style>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

.filter-table-wrapper > div {
    border-radius: 10px;
    border: 1px solid #DDDDE3;
    margin: 20px;
}
.filter-custom-table {
    margin: 0 !important;
    font-family: 'NanumGothic';
}
.filter-custom-table tr td {
    border-top: none;
    border-bottom: 1px solid #DDDDE3;
}
.filter-custom-table tr:last-child td {
    border-bottom: none;
}
.filter-custom-table tr td.head {
    width: 26%;
    background-color: #F6F6FA;
    border-right: 1px solid #DDDDE3;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
    vertical-align: middle;
}
.filter-custom-table tr:first-child td:first-child {
    border-radius: 10px 0 0 0;
}
.filter-custom-table tr:first-child td:last-child {
    border-radius: 0 10px 0 0;
}
.filter-custom-table tr:last-child td:first-child {
    border-radius: 0 0 0 10px;
}
.filter-custom-table tr:last-child td:last-child {
    border-radius: 0 0 10px 0;
}
.filter-custom-table .custom-control-label {
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
}
.filter-custom-table .custom-control-input:checked ~ .custom-control-label::before {
    width: 16px;
    height: 16px;
    background: #1755CC;
    border: none;
    border-radius: 4px;
}
.filter-custom-table .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    width: 16px;
    height: 16px;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M4 7L6 9L10 5" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>');
    background-position: 1px 1px;
}
.filter-custom-table .filter-custom-input {
    position: relative;
}
.filter-custom-table input.form-control {
    background-color: #FFF;
    border-radius: 10px 0 0 10px !important;
}
.filter-custom-table input.form-control:only-child {
    border-radius: 10px !important;
}
.filter-custom-table .form-control:focus {
    border: 1px solid #E7E7EE;
    border-right: none;
    box-shadow: none;
}
.filter-custom-table .btn-secondary {
    background-color: #FFF;
    color: #C4C4CD;
    border-radius: 0 10px 10px 0;
    border: 1px solid #E7E7EE;
    border-left: none;
}
</style>